import React, { useState, useEffect } from "react";
import { withStyles, Grid } from "@material-ui/core";
import { getCountries } from "../../../../../../API/Country";
import { styles } from "./styles";

import TextField from "../../../../../../Component/Forms/TextField";
import SearchableSelect from "../../../../../../Component/Forms/SearchableSelect";
import { useTranslation } from "react-i18next";

const RegulatorForm = (props) => {
  const { onFieldChange, formErrors, classes } = props;
  const { t } = useTranslation();

  const options = [
    {
      label: t("labels.common.yes"),
      value: 1,
    },
    {
      label: t("labels.common.no"),
      value: 0,
    },
  ];
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(null);
  const [equivalent, setEquivalent] = useState(null);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const result = await getCountries();
        const { data = [] } = result;
        setCountries(data.map((val) => ({ value: val.id, label: val.name })));
      } catch (error) {
        console.log(error);
      }
    };
    loadCountries();
  }, []);

  const handleNameChange = (value) => {
    onFieldChange && onFieldChange(value, "regulator_name");
  };

  const handleCodeChange = (value) => {
    onFieldChange && onFieldChange(value, "regulator_code");
  };

  const handleCountryChange = (c) => {
    setCountry(c)
    onFieldChange && onFieldChange(c ? c.value : null, "country_id");
  };

  const handleEquivalentChange = (eq) => {
    setEquivalent(eq)
    onFieldChange && onFieldChange(eq ? eq.value : null, "is_equivalent");
  };


  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.regulatorList.regulatorForm.regulatorCode")}
          type="text"
          onChange={handleCodeChange}
        />
        {formErrors["regulator_code"] && <div className={classes.errorText}>{formErrors["regulator_code"]}</div>}
      </Grid>
      <Grid item xs={9}>
        <TextField
          label={t("labels.country.regulatorList.regulatorForm.regulatorName")}
          required={true}
          type="text"
          onChange={handleNameChange}
        />
        {formErrors["regulator_name"] && <div className={classes.errorText}>{formErrors["regulator_name"]}</div>}
      </Grid>
      <Grid item xs={6}>
        <SearchableSelect
          label={t("labels.country.regulatorList.regulatorForm.country")}
          options={countries}
          value={country}
          changeHandler={handleCountryChange}
          required={true}
        />
        {formErrors["country_id"] && <div className={classes.errorText}>{formErrors["country_id"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <SearchableSelect
          label={t("labels.country.regulatorList.regulatorForm.equivalent")}
          options={options}
          value={equivalent}
          changeHandler={handleEquivalentChange}
          disableClearable={true}
          required={true}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(RegulatorForm);
